import type { PortraitStudent } from '@/api/types/portrait'

/** What groups a student's portrait rows: their `studentBodyId`. A row without one stands alone,
 *  keyed by its own `portraitId`. */
export function studentKeyOf(student: Pick<PortraitStudent, 'studentBodyId' | 'portraitId'>) {
  return student.studentBodyId || student.portraitId
}
